import React from 'react';

// Aurora glow blobs that drift softly behind the stars
const AURORA = [
  { color: 'rgba(110,208,255,0.40)', top: '6%', left: '10%', size: 560, dur: 18, delay: 0 },   // cyan
  { color: 'rgba(168,120,255,0.38)', top: '12%', left: '68%', size: 600, dur: 22, delay: -5 },  // violet
  { color: 'rgba(94,217,154,0.30)', top: '62%', left: '16%', size: 520, dur: 20, delay: -9 },   // green
  { color: 'rgba(255,138,200,0.22)', top: '66%', left: '66%', size: 540, dur: 24, delay: -3 },  // pink
];

function Starfield() {
  // Generate 70 stars once
  const stars = React.useMemo(
    () =>
      Array.from({ length: 70 }, () => ({
        left: Math.random() * 100,
        top: Math.random() * 100,
        size: Math.random() * 2 + 1,
        delay: Math.random() * 4,
        dur: 2.5 + Math.random() * 3,
        bright: 0.3 + Math.random() * 0.6,
      })),
    []
  );

  return (
    <div className="starfield-layer" aria-hidden="true">
      {/* aurora glow blobs (painted first = behind the stars) */}
      {AURORA.map((a, i) => (
        <div
          key={'a' + i}
          style={{
            position: 'absolute',
            top: a.top,
            left: a.left,
            width: a.size,
            height: a.size,
            borderRadius: '50%',
            background: `radial-gradient(circle, ${a.color} 0%, transparent 70%)`,
            filter: 'blur(40px)',
            pointerEvents: 'none',
            animation: `auroraDrift ${a.dur}s ease-in-out ${a.delay}s infinite`,
          }}
        />
      ))}

      {stars.map((s, i) => (
        <span
          key={i}
          style={{
            position: 'absolute',
            left: s.left + '%',
            top: s.top + '%',
            width: s.size,
            height: s.size,
            borderRadius: '50%',
            background: '#fff',
            opacity: s.bright,
            boxShadow: '0 0 ' + s.size * 2 + 'px rgba(180,200,255,0.8)',
            animation: `yapperTwinkle ${s.dur}s ease-in-out ${s.delay}s infinite`,
          }}
        />
      ))}
    </div>
  );
}

export default Starfield;
